module.exports = __webpack_public_path__ + "img/sc.efe0b090.svg";